export default "__VITE_ASSET__jLXloYad__"